import {addDays, formatISO} from "date-fns";
import pluralize from "pluralize";

import {useCurrentUserContext} from "@/components/context/hooks.ts";
import {autoDuration, dateOnly} from "@/lib/format.tsx";
import {MonitoringServiceType, PerformanceDataType, Service} from "@/lib/types/checks.ts";
import {ResponseTimeChart} from "@/pages/checks/list/components/ResponseTimeCharts.tsx";

type Response = {
  service: Service;
};

export const CheckResponseTime = ({service}: Response) => {
  const {user} = useCurrentUserContext();
  let response = null;

  if (service.is_paused) {
    return response;
  }

  if (
    [PerformanceDataType.RESPONSE_TIME, PerformanceDataType.JITTER_DELTA, PerformanceDataType.CUSTOM].includes(
      service.performanceDataType
    )
  ) {
    if (service.responseTimeDatapoints.length > 0) {
      response = (
        <ResponseTimeChart
          responseTimeSLA={service.msp_response_time_sla}
          data={service.responseTimeDatapoints}
          width={120}
          height={45}
        />
      );
    } else if (service.cached_response_time >= 0.0) {
      response = autoDuration(service.cached_response_time);
    }
  } else if (
    service.performanceDataType === PerformanceDataType.RUM_LOAD_TIME &&
    service.responseTimeDatapoints.length > 0
  ) {
    response = autoDuration(service.responseTimeDatapoints[0].value);
  } else if (
    service.performanceDataType === PerformanceDataType.DAYS_TO_EXPIRY &&
    service.cached_response_time >= 1.0
  ) {
    const days: number = Math.floor(service.cached_response_time);
    const validUntil = addDays(new Date(), days);
    response = (
      <div className="d-flex flex-column">
        <span className="fw-semibold">Expires: {pluralize("day", days, true)}</span>
        <span className="fs-7">
          {dateOnly(formatISO(validUntil), user!.current_date_format, user!.account!.timezone)}
        </span>
      </div>
    );
  } else if (service.monitoring_service_type === MonitoringServiceType.PAGESPEED && service.cached_uptime_grade) {
    response = service.cached_uptime_grade;
  }

  return response;
};
